import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import { getActionCompletedTime } from '../../utils/actionTiming';

const eventMappings = {};
eventMappings[actions.POLL_SUCCESS] = [trackCompleteAction];

export default function trackPoll(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

const getPollAnsweredText = state => {
    const action = state.widget.actions.find(
        a => a.identifier === state.poll.lastAnsweredPoll.actionIdentifier
    );

    return action.possibleAnswers.find(a => a.id === state.poll.lastAnsweredPoll.answerId)
        .text;
};

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        amount: state.donation.selectedAmount,
        actionCompleteTime: getActionCompletedTime(state, 'poll')(),
        answerText: getPollAnsweredText(state)
    });
}



// WEBPACK FOOTER //
// ./src/containers/Poll/tracking.js